module.exports = __webpack_public_path__ + "static/media/yourjourney.0d8fe511.png";